jQuery( document ).ready( function( $ ){

    $( document ).on( 'click', '.play-soundbite', function(){
        $( this ).next( '.soundbite-file' ).trigger( 'play' );
    });

});